import React from "react";
import { getMe } from "../api/getme";
import { getConfig } from "../config";
import { AuthenticatedUser, Me } from "./AuthenticatedUser";

function logout() 
{
  const {BaseBffUrl} = getConfig();
  window.location.assign(`${BaseBffUrl}/auth/logout?returnUrl=/`);  
}

type AuthState =
  | { status: "loading"; authenticatedUser: AuthenticatedUser; logout: VoidFunction}
  | { status: "unauthenticated"; authenticatedUser: AuthenticatedUser; logout: VoidFunction } 
  | { status: "authenticated"; authenticatedUser: AuthenticatedUser; logout: VoidFunction }
  | { status: "unregistered"; authenticatedUser: AuthenticatedUser; logout: VoidFunction };

const IdentityContext = React.createContext<AuthState>({ 
  status: "loading", 
  authenticatedUser: AuthenticatedUser.SetDefault(),
  logout
});

export function useIdentityContext() {
  return React.useContext(IdentityContext);
}

export function IdentityContextProvider({ children }: { children: React.ReactNode }) {
  const [state, setState] = React.useState<AuthState>({ status: "loading", authenticatedUser: AuthenticatedUser.SetDefault(), logout });

  React.useEffect(() => {
    
    getMe(false)
      .then((me: Me) => {
          
        var user = new AuthenticatedUser(me);
        if (me?.authenticated) 
        {
          if (user.isRegistered()) setState({ status: "authenticated", authenticatedUser: user, logout });
          else setState({ status: "unregistered", authenticatedUser: user, logout });
        }
        else setState({ status: "unauthenticated", authenticatedUser: AuthenticatedUser.SetDefault(), logout });
      })
      .catch(() => setState({ status: "unauthenticated", authenticatedUser: AuthenticatedUser.SetDefault(), logout}));
  }, []);

  return <IdentityContext.Provider value={state}>{children}</IdentityContext.Provider>;
}

